import is from '@sindresorhus/is';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { Thread, ThreadList } from '../../data-contract/chat';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { chatKeys } from './query-keys';

export const useMarkChatThreadRead = (): UseMutationResult<unknown, Error, { readonly threadId: string }> => {
    const queryClient = useQueryClient();
    const { markChatThreadRead } = useApplicationFetchers();

    return useMutation({
        mutationFn: async ({ threadId }) => {
            const result = await markChatThreadRead(threadId);

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        onMutate: ({ threadId }) => {
            queryClient.setQueryData<ThreadList>(chatKeys.threads(), (existing) => {
                if (is.undefined(existing)) return existing;

                return {
                    ...existing,
                    threads: existing.threads.map((thread) =>
                        thread.id === threadId ? { ...thread, unreadMessagesAvailable: false } : thread,
                    ),
                };
            });
            queryClient.setQueryData<Thread>(chatKeys.thread(threadId), (existing) =>
                is.undefined(existing) ? existing : { ...existing, unreadMessagesAvailable: false },
            );
        },
    });
};
